import {ViewModel} from "@/main-page/jsParseEngine/ViewModel";
import {usePageModelsStore} from "@/store/modules/pageModels";
import {useDataSourceStore} from "@/store/modules/dataSourceStore";
import {storeToRefs} from "pinia";
import {useOpenSubPage} from "@/main-page/gridCellCtlShow/hooks/useOpenSubPage";
import {useComEvent} from "@/main-page/ctls/hooks/useComEvent";
/**
 * 打开简易流程待办记录
 */
const openFlowDealPage=function ({record,viewModel}){
  let url='/flowList/simplFlowDeal';
  // 页签名取流程标题：页签系统对 /flowList/simplFlowDeal 特判 query.flowTitle 命名（超长截取前 25 位）
  const flowTitle=(record.processName||record.flowTitle||record.proTitle||record.title||'').slice(0,25);
  let paramsDef={
    recordId:record.flowId ? record.flowId : '',
    tableCode:record.tableCode ? record.tableCode : '',
    formDataId:record.formDataId ? record.formDataId : '',
    pageFrom:'waitDeal',
    flowTitle
  };
  url=viewModel.initUrlParams(url, paramsDef);
  viewModel.routerPath(url,paramsDef,'')
}

/**
 * 组装待办消息页签标题：与消息列表展示文案一致（titleContentPre + ' : ' + 标题），
 * 随 query.flowTitle 传入，流程处理页读取后设置页签名（useSimplFlowDeal.syncTabTitle）；
 * 页签按 fullPath 去重：同一消息两次点击 fullPath 相同 => 激活已有页签不新开
 */
const getMsgTabTitle=function (msgRecord,recordInfo){
  let title=(msgRecord&&msgRecord.title)||'';
  try{
    const content=typeof msgRecord.content==='string'?JSON.parse(msgRecord.content):msgRecord.content;
    if(content&&content.titleContentPre){
      title=content.titleContentPre+' : '+title;
    }
  }catch (e){
    // content 非约定 JSON 时直接用消息标题
  }
  if(!title){
    title=(recordInfo&&(recordInfo.flowTitle||recordInfo.processName))||'';
  }
  return title;
}

/**
 * 待办消息出来
 */
const dealHandleMsg=function ({recordInfo,viewModel,msgRecord}){
  if(recordInfo.msgFlowType && recordInfo.msgFlowType==='flow'){
    let url='/flowBpmList/flowList/simplFlowDeal';
    let paramsDef={
      recordId:recordInfo.flowId ? recordInfo.flowId : '',
      tableCode:recordInfo.tableCode ? recordInfo.tableCode : '',
      formDataId:recordInfo.businessKey ? recordInfo.businessKey : '',
      pageFrom:'waitDeal',
      processInstanceId:recordInfo.processInstanceId ? recordInfo.processInstanceId : '',
      taskId:recordInfo.taskId ? recordInfo.taskId : '',
      flowType:recordInfo.flowType ? recordInfo.flowType : '',
      nodeId:recordInfo.taskDefinitionKey ? recordInfo.taskDefinitionKey : '',
      flowId:recordInfo.flowId ? recordInfo.flowId : '',
      formModuleCode:recordInfo.formModuleCode ? recordInfo.formModuleCode : '',
      formPageCode:recordInfo.formPageCode ? recordInfo.formPageCode : '',
      // 页签名取消息标题
      flowTitle:getMsgTabTitle(msgRecord,recordInfo)
    };
    url=viewModel.initUrlParams(url, paramsDef);
    viewModel.routerPath(url,paramsDef,'')
  }else{//recordInfo.msgFlowType==='simpleFlow'
    const content=JSON.parse(msgRecord.content);
    let url='/flowList/simplFlowDeal';
    const tableCode=(content&&content.jumpConfigs)?content.jumpConfigs.moduleCode:recordInfo.tableCode ? recordInfo.tableCode : '';
    let paramsDef={
      recordId:recordInfo.flowId ? recordInfo.flowId : '',
      tableCode:tableCode.replace(/FlowDeal/g,''),
      formDataId:(msgRecord&&msgRecord.formatContent)?msgRecord.formatContent.id:recordInfo.id ? recordInfo.id : '',
      pageFrom:'flowDeal',
      // 页签名取消息标题
      flowTitle:getMsgTabTitle(msgRecord,recordInfo)
    };
    url=viewModel.initUrlParams(url, paramsDef);
    viewModel.routerPath(url,paramsDef,'')
  }
}


export function useMsgHook({router,winTemConfig,msgDetailFlag},newsListRef){

  const pageModelsStore: any = usePageModelsStore();
  const dataSourceStore:any =useDataSourceStore();
  const {state} = storeToRefs(pageModelsStore);

  /**
   * 初始化消息 viewModel
   */
  const initMsgViewModel=function (){
    const {openSubComPage} = useOpenSubPage();
    const viewModel = new ViewModel({viewPage:{}, pageModelsStore,dataSourceStore,state});
    viewModel.openSubComPage=openSubComPage;
    (window as any).viewModelObj=viewModel;
  }

  const openMsgByConfig=function (record){
    let tempConfigs:any=record.messageSetting.tempConfigs;

    if(typeof(tempConfigs)==='string'&&tempConfigs){
      tempConfigs=JSON.parse(tempConfigs);
    }
    //如果是无点击操作
    if(tempConfigs.openType==="notClick"){
      router.push({ path: '/xm-runing-extend/msgMain' });
      return ;
    }
    //如果打开新窗口
    if(tempConfigs.openType==='newWindow'){
      winTemConfig.value=tempConfigs;
      msgDetailFlag.value = true;
    }
    //如果是新开界面
    if(tempConfigs.openType==='newPage'){
      window.open(tempConfigs.pathUrl)
    }
    //如果是路由跳转
    if(tempConfigs.openType==='routerPath'){
      window.appObj.$router.push({path:tempConfigs.pathUrl})
    }
    //打开抽屉部件
    if(tempConfigs.openType==='newDrawer'){
      const {moduleCode,pageCode}=tempConfigs.jumpConfigs;
      if((moduleCode+'').indexOf("FlowDeal")>0&&(pageCode+'').indexOf("FlowDeal")>0){
        const viewModel=(window as any).viewModelObj;
        (window as any).openFlowDealPage({record,pageCode,moduleCode,viewModel});
      }
    }
  }


  
  // 消息详情展示
  const onNoticeClick = function (record: any) {
    try {
      const recordInfo = record.formatContent;
      const {viewModel} = useComEvent({events:[]});
      if (record.inBoxType === 'waitHandleMessage') {
        dealHandleMsg({recordInfo,viewModel,msgRecord:record});
      }
      if (record.inBoxType === 'platformMessage') {
        newsListRef.value?.showMsgDrawer(record);
      }
    } catch (error) {
      console.log(error,"查看待办详情失败");
    }

  }

  return {
    initMsgViewModel,
    onNoticeClick,
    openMsgByConfig
  }
}
(window as any).openFlowDealPage=openFlowDealPage;
